import React from 'react';
import {connect} from 'react-redux';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';
import {SimpleSelect as SimpleSelectize} from 'react-selectize';
import InputText from 'components/atoms/inputs/input-text';
import {generateSignature} from 'helpers/hash';
import EnableSwitch from 'components/organisms/projection-boost-rule/enable-switch';
import AbstractSettings, {sortPlayers, getPlayerOptionValue} from './../abstract-settings';

const boostStatement = {
    boostType: 'increase',
    boostFor: 'player',
    boostedPositions: [],
    boostedPlayer: '',
    isSameTeam: 1,
    boostPercent: 1,
};

class Settings extends AbstractSettings {
    constructor(props) {
        super(props);
        this.state = {
            statementType: 'player',
            keyPosition: '',
            keyPlayer: '',
            boostStatements: {
                [generateSignature()]: cp(boostStatement),
            },
        };
    }

    getKeyPlayerView() {
        const {players} = this.props;

        const options = sortPlayers(Object.values(players.all())).map((player) => getPlayerOptionValue(player));

        const selectedPlayer = players.getPlayer(this.state.keyPlayer);

        return (
            <SimpleSelectize
                className="flex-1"
                key={'keyPlayer'}
                defaultValue={''}
                onValueChange={this.onChangeKeyPlayer.bind(this)}
                options={options}
                value={getPlayerOptionValue(selectedPlayer)}
                placeholder={'Select player'}
            />
        );
    }

    getBoostedPlayerView(statementKey) {
        const {players} = this.props;
        const boostStatement = this.state.boostStatements[statementKey];

        const options = sortPlayers(Object.values(players.all())).map((player) => getPlayerOptionValue(player));

        const selectedPlayer = players.getPlayer(boostStatement.boostedPlayer);

        return (
            <div className="form-line">
                <SimpleSelectize
                    className="flex-1"
                    key={`boostedPlayer-${statementKey}`}
                    defaultValue={''}
                    onValueChange={((value) => this.onChangeBoostedPlayer(statementKey, value)).bind(this)}
                    options={options}
                    value={getPlayerOptionValue(selectedPlayer)}
                    placeholder={'Select player'}
                />
            </div>
        );
    }

    getBoostStatementView(statementKey) {
        const boostStatement = this.state.boostStatements[statementKey];

        return (
            <div className="form-inline-flex separate-group" key={`boostStatement-${statementKey}`}>
                <SimpleSelect
                    className="form-control input-md"
                    value={boostStatement.boostType}
                    options={{decrease: 'Decrease', increase: 'Increase'}}
                    onChange={((value) => this.onChangeBoostType(statementKey, value)).bind(this)}
                />
                <div className="form-text">projection for</div>
                {this.getBoostedPlayerView(statementKey)}
                <div className="form-text">by</div>
                <InputText
                    key={`boostPercent-${generateSignature()}`}
                    className="input-sm"
                    percent
                    value={boostStatement.boostPercent}
                    onBlur={((value) => this.onBlurBoostPercent(statementKey, value)).bind(this)}
                />
                {this.getRemoveBoostStatementView(statementKey)}
            </div>
        );
    }

    getRemoveBoostStatementView(statementKey) {
        return (
            <span onClick={(() => this.onRemoveStatement(statementKey)).bind(this)} className="close-rule">
                <i className="fa fa-times-circle"></i>
            </span>
        );
    }

    render() {
        return (
            <div className="mb15">
                <h3>Sim Boost Rules</h3>
                <EnableSwitch />
                <div className="gap-y">
                    <div className="form-inline-flex">
                        <div className="form-line">
                            <div className="form-text">If</div>
                            {this.getKeyPlayerView()}
                        </div>
                        <div className="form-text">is in lineup then</div>
                    </div>
                    {Object.keys(this.state.boostStatements).map((key) => this.getBoostStatementView(key))}
                    <div className="filter-buttons">
                        <button type="button" onClick={this.onAddStatement.bind(this)} className="btn btn-outline">
                            Add Statement
                        </button>
                        <button type="button" onClick={this.onAddRuleItem.bind(this)} className="btn">
                            Add Rule
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        projectionBoostRule,
        sportConfig,
        playersData: {players},
    } = state;

    return {
        projectionBoostRule,
        sportConfig,
        players,
    };
}

export default connect(mapStatesToProps)(Settings);
